import React, {Component} from 'react';
import {Button, Input, Form} from 'antd';
const FormItem = Form.Item;

class ResetForm extends Component {
  constructor (props){
    super(props);
    this.state = {
      confirmDirty: false,
    }
  }

  // 检查密码是否一致
  checkPassword = (rule, value, callback) => {
    const form = this.props.form;
    // 输入值与 'password' 不一致时，显示“不一样”的提示。
    if (value && value !== form.getFieldValue('password')) {
      callback('输入的两个密码不一致！');
    } else {
      callback();
    }
  }
  //
  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], {force: true});
    }
    callback();
  }
  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({
      confirmDirty: this.state.confirmDirty || !!value
    });
  }

  render() {
    const {form} = this.props;
    const {getFieldDecorator} = form;
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 6
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 18
        }
      }
    };
    const helpText = "密码必须为6~15位，至少包括数字、字母、符号中的两种"
    return (
      <Form>
        <FormItem {...formItemLayout} label="新密码：" help={helpText}>
          {getFieldDecorator('password', {
            rules: [
              {
                required: true,
                message: '请输入新密码'
              }, {
                validator: this.checkConfirm
              }
            ]
          })(<Input type="password" placeholder="输入新密码"/>)}
        </FormItem>
        <FormItem {...formItemLayout} label="确认密码：">
          {getFieldDecorator('confirm', {
            rules: [
              {
                required: true,
                message: '确认新密码'
              }, {
                validator: this.checkPassword
              }
            ]
          })(<Input type="password" onBlur={this.onConfirmBlur} placeholder="输入确认密码"/>)}
        </FormItem>
      </Form>
    )
  }
}

export default Form.create()(ResetForm);;


// WEBPACK FOOTER //
// ./src/components/login/resetForm.js